module.exports = __webpack_public_path__ + "img/btn_banner_share.5eaf7d52.png";